export default __webpack_public_path__ + "static/media/JobSix1.c76c511f.jpg";